import config from "@/config";
import { useAxios } from "@vueuse/integrations/useAxios";
import axios from "axios";

export default function useLiveopsApiClient() {
  const client = axios.create({
    baseURL: config.liveopsApiBaseUrl,
  });

  return {
    useAxios,
    client,
  };
}
